<template>
  <v-container grid-list-lg>
    <v-layout
      row
      wrap
      class="mt-3"
    >

      <v-flex
        xs12
        sm6
        md4
        class="mt-5"
      >
        <v-card>
          <v-sheet
            elevation="8"
            color="grey darken-1"
            dark
            class="v-sheet--offset mx-auto"
            max-width="calc(100% - 32px)"
          >
            <div class="subheading pa-3">
              <v-icon class="mr-2">fa-address-book</v-icon>Adres
            </div>
          </v-sheet>
          <v-progress-linear
            indeterminate
            v-if="profile.isFetching"
          />
          <template v-else>
            <v-card-title primary-title>{{profile.tenant}}</v-card-title>
            <v-card-text class="address">
              <div>
                <span class="address__icon">
                  <v-icon small>fa-address-book</v-icon>
                </span>{{profile.address}}
              </div>
              <div>
                <span class="address__icon">
                  <v-icon small>fa-envelope</v-icon>
                </span>
                {{profile.email}}
              </div>
              <div>
                <span class="address__icon">
                  <v-icon small>fa-phone</v-icon>
                </span>
                {{profile.phone}}
              </div>
            </v-card-text>
          </template>

        </v-card>
      </v-flex>
      <v-flex
        xs12
        sm6
        md4
        class="mt-5"
      >
        <v-card>
          <v-sheet
            elevation="8"
            color="grey darken-1"
            dark
            class="v-sheet--offset mx-auto"
            max-width="calc(100% - 32px)"
          >
            <div class="subheading pa-3">
              <v-icon class="mr-2">fa-building</v-icon>Woningbouwcorporatie
            </div>
          </v-sheet>
          <v-progress-linear
            indeterminate
            v-if="profile.isFetching"
          />
          <template v-else>
            <v-card-title primary-title>{{profile.housingCooperative.name}}</v-card-title>
            <v-card-text>
              <v-img
                v-if="profile.housingCooperative.logoUrl"
                max-height="192"
                max-width="192"
                contain
                :src="profile.housingCooperative.logoUrl"
              />
            </v-card-text>
          </template>

        </v-card>
      </v-flex>
      <v-flex
        xs12
        sm6
        md4
        class="mt-5"
      >
        <v-card>
          <v-sheet
            elevation="8"
            color="grey darken-1"
            dark
            class="v-sheet--offset mx-auto"
            max-width="calc(100% - 32px)"
          >
            <div class="subheading pa-3">
              <v-icon class="mr-2">fa-solar-panel</v-icon>Installatie
            </div>
          </v-sheet>
          <v-progress-linear
            indeterminate
            v-if="installation.isFetching"
          />
          <v-list
            dense
            v-else
          >
            <v-list-tile>
              <v-list-tile-content>Aantal panelen:</v-list-tile-content>
              <v-list-tile-action-text class="secondary--text">
                {{ installation.numberOfPanels }}
              </v-list-tile-action-text>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-content>Locatie panelen:</v-list-tile-content>
              <v-list-tile-action-text class="secondary--text">
                {{ installation.locationPanels }}
              </v-list-tile-action-text>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-content>Type installatie:</v-list-tile-content>
              <v-list-tile-action-text class="secondary--text">
                {{ installation.installationType }}
              </v-list-tile-action-text>
            </v-list-tile>
          </v-list>

        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  computed: {
    profile() { return this.$store.state.profile.user; },

    installation() { return this.$store.state.profile.installation; },
  },

  created() {
    this.$cache.keep(24 * 60 * 60 * 1000).dispatch('profile/getProfile');
    this.$cache.keep(24 * 60 * 60 * 1000).dispatch('profile/getInstallation');
  },
};
</script>

<style lang="scss" scoped>
.address {
  line-height: 2em;

  &__icon {
    display: inline-block;
    margin-right: 4px;
    width: 20px;
  }
}

.v-layout {
  align-items: stretch;
}

.flex {
  display: flex;
}

.v-card {
  flex-grow: 1;
}
</style>
